import React from 'react';
import './App.css'
import Header from './component/header';
const App = () => {
 
  return (
        <>
     <Header/>
        </>
  );
}

export default App;
